
import { Directive, ElementRef, HostListener, Inject, Renderer2, DOCUMENT } from '@angular/core';

@Directive({
    selector: '[appParticipantListFluidMaxHeight]',
    standalone: false
})
export class ParticipantListFluidMaxHeightDirective {
  constructor(
    @Inject(DOCUMENT) private readonly doc: Document,
    private readonly renderer: Renderer2,
    private readonly el: ElementRef
  ) {
    this.updateMaxHeight();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateMaxHeight();
  }

  /**
   * Returns the offsetHeight including bottom/top margins of provided element
   */
  outerHeight(el: HTMLElement, doc: Document): number {
    return el
      ? ['bottom', 'top']
          .map((side) => this.getComputedStyleInt(`margin-${side}`, el, doc))
          .reduce((cur, acc) => cur + acc, el.offsetHeight)
      : 0;
  }

  getComputedStyleInt(styleProp: string, el: HTMLElement, doc: Document): number {
    return parseInt(doc.defaultView.getComputedStyle(el)[styleProp]);
  }

  handleHeightChange(doc: Document) {
    const main: HTMLElement = doc.querySelector('main');
    const sidebar: HTMLElement = doc.querySelector('[data-sidebar-container]');
    const signingDetails: HTMLElement = doc.querySelector('[data-sidebar-signing-details]');

    const mainOuterHeight = this.outerHeight(main, doc);
    const sidebarPaddingTop = this.getComputedStyleInt('padding-top', sidebar, doc);
    const sidebarGap = this.getComputedStyleInt('gap', sidebar, doc);
    const signingDetailsOuterHeight = this.outerHeight(signingDetails, doc);

    const maxHeight =
      mainOuterHeight - sidebarPaddingTop - 2 * sidebarGap - signingDetailsOuterHeight;

    this.renderer.setStyle(this.el.nativeElement, 'max-height', `${maxHeight}px`);
  }

  updateMaxHeight(): void {
    requestAnimationFrame(() => {
      this.handleHeightChange(this.doc);
    });
  }
}
